import { CartItem, CartItemSlot } from '@xylabs/sdk-coin-js'

import sentinelImage from './img/card-front-shaped-final.svg'
import threePackImage from './img/sentinel-nfc-3-pack.png'

export const cartItemsNfc = new Map<CartItemSlot, CartItem>()

cartItemsNfc.set(CartItemSlot.Primary, {
  COGS: 1,
  defaultAdd: true,
  image: sentinelImage,
  msrp: 50,
  note: 'Requires NFC compatibility. Not compatible with iPhone 5, 6, 6+ or SE (2016), and some older Android Devices.',
  planId: 'XYO-SENTINEL-NFC-01',
  price: 0,
  quantity: 1,
  ship: true,
  subtitle: '(Normal Price: $50)',
  title: '1 SentinelX NFC Device: Free',
  value: 0,
})

cartItemsNfc.set(CartItemSlot.Shipping, {
  COGS: 0.68,
  defaultAdd: true,
  msrp: 12.95,
  planId: 'XY-SHIPPING-FULL-2',
  price: 12.95,
  quantity: 1,
  ship: true,
  subtitle: '(Non-US $17.95)',
  title: 'Shipping Cost: $12.95 (price you pay)',
  value: 12.95,
})

cartItemsNfc.set(CartItemSlot.ShippingIntl, {
  COGS: 2.65,
  msrp: 17.95,
  planId: 'XY-SHIPPING-INTL-1',
  price: 17.95,
  quantity: 1,
  ship: true,
  subtitle: '(US $12.95)',
  title: 'Shipping Cost: $17.95 (price you pay)',
  value: 17.95,
})

cartItemsNfc.set(CartItemSlot.Trial, {
  COGS: 0,
  defaultAdd: true,
  planId: 'XYO-COIN-PRO-3D-TRIAL-34-95',
  planType: 'COIN Pro',
  price: 0,
  quantity: 1,
  ship: false,
  value: 42,
})

cartItemsNfc.set(CartItemSlot.Subscription, {
  COGS: 0,
  planId: 'XYO-COIN-PRO-34-95',
  planType: 'COIN Pro',
  price: 34.95,
  quantity: 1,
  ship: false,
  value: 34.95,
})

cartItemsNfc.set(CartItemSlot.Upsell, {
  COGS: 3,
  image: threePackImage,
  planId: 'XYO-SENTINEL-NFC-3-PACK-01',
  price: 67,
  quantity: 1,
  ship: true,
  value: 67,
})

cartItemsNfc.set(CartItemSlot.SemiAnnual, {
  COGS: 0,
  planId: 'COIN-PRO-SEMIANNUAL-PLAN-110-82',
  planType: 'COIN Pro',
  price: 110.82,
  quantity: 1,
  ship: false,
  value: 110.82,
})
